import { mockBuilder } from '../utils/builderHelper.es.js';
import { Subgenre } from './Subgenre.es.js';

/** @module Mocks */ /** typedoc */
function aSubgenre() {
    return mockBuilder(new Subgenre('Subgenre Name', 'Localized Subgenre Name', 'Subgenre Category', 'Localized Category Name'));
}

export { aSubgenre };
